import React, { FC } from "react";
import styles from "./Switch.module.css";
import classNames from "classnames";
import Colors from "ui-kit/colors";

type SwitchProps = {
  active: boolean;
  activeColor?: keyof typeof Colors;
};

const Switch: FC<SwitchProps> = ({ active, activeColor = "green300" }) => {
  return (
    <div className={styles.container}>
      <div
        className={classNames(styles.track, active && styles.active)}
        style={{
          backgroundColor: active ? Colors[activeColor] : Colors.grey200,
        }}
      />
      <div className={classNames(styles.indicator, active && styles.active)} />
    </div>
  );
};

export default Switch;
